export default "__VITE_ASSET__229393c8__"